import { getConfig } from '@belong/configs/next/config';

export const getEnvVars = (): Partial<ReturnType<typeof getConfig>['publicRuntimeConfig']> => {
  return getConfig().publicRuntimeConfig;
};
